export default {
    data(){
        return {
            loader: null,
            message_slot: null
        }
    },
    mounted() {
        this.loader = $('#loading-overlay');
        this.message_slot = $('#loading-overlay>span');
    },
    methods: {
        showLoader(message){
            this.message_slot.text(message);
            this.loader.css('display', 'flex');
        },
        hideLoader(){
            this.loader.hide();
            this.message_slot.text('');
        }
    }
}
